import {NodePlopAPI} from "plop";
import generators from "./generators";
import {runCommandActionType} from "./action-types/run-command.action-type";

export function integralGenerator(plop: NodePlopAPI) {
    runCommandActionType(plop);
    generators(plop);
}
